import { ValueRegistryItem } from '../../../registry/value/ValueRegistryItem';
import { ValueRegistryCategory } from '../../../registry/value/ValueRegistryCategory';
export class ValueRegistryDraftStage extends ValueRegistryCategory {
    label = 'Stage';
    constructor(parent) {
        super(parent);
        super.init();
    }
    translateXOfGap = () => new ValueRegistryItem({
        label: 'TranslateXOfGap',
        value: ({ question }) => {
            return !!question && question.questionPart.actorContent.global.activeOfKey('gap').length > 0 && question.questionPart.actorContent.global.activeOfKey('gap')[0].inner.valueOf.translateX;
        }
    });
    translateYOfGap = () => new ValueRegistryItem({
        label: 'TranslateYOfGap',
        value: ({ question }) => {
            return !!question && question.questionPart.actorContent.global.activeOfKey('gap').length > 0 && question.questionPart.actorContent.global.activeOfKey('gap')[0].inner.valueOf.translateY;
        }
    });
}
